import { render, staticRenderFns } from "./user-tag.vue?vue&type=template&id=6350dd8b&scoped=true&"
import script from "./user-tag.vue?vue&type=script&lang=js&"
export * from "./user-tag.vue?vue&type=script&lang=js&"
import style0 from "./user-tag.vue?vue&type=style&index=0&id=6350dd8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350dd8b",
  null
  
)

export default component.exports